import React from "react";
import {Button, Dialog, Zoom} from "@mui/material";
import {observer} from "mobx-react";
import './modal.scss'
import CloseIcon from "@mui/icons-material/Close";
import {SelectDomainStep} from "../OnBoarding/SharedSteps";
import {useStores} from "../../Hooks";

const SwitchDomainDialog = observer(() => {
    const {generalStore, modalStore} = useStores();

    async function onEnter() {
        const promise = generalStore.getDomainsList();
        const errorMessage = generalStore.translate('cannotFetchWorkspaces');
        const successMessage = generalStore.translate('');
        const loadingMessage = generalStore.translate('gettingWorkspaces') + '...';
        modalStore.isLoadingWorkspaces = true;
        await modalStore.runAsync(promise, errorMessage, successMessage, loadingMessage);
        modalStore.isLoadingWorkspaces = false;
        generalStore.activeDomains = generalStore.activeDomains.filter(workspace => generalStore.workspace !== workspace);
    }

    function closeModal() {
        modalStore.isSwitchDomainModalOpen = false;
    }

    return (
        <Dialog
            TransitionProps={{
                onEnter
            }}
            onClose={closeModal}
            open={modalStore.isSwitchDomainModalOpen}
            className='dialog switch-domain-dialog'
            TransitionComponent={Zoom}
        >
            <Button
                disableElevation
                disableFocusRipple
                disableRipple
                disableTouchRipple
                className='close-button switch-domain-close-button'
                onClick={closeModal}
            >
                <CloseIcon className='close-icon'/>
            </Button>
            <SelectDomainStep/>
        </Dialog>
    )
});

export default SwitchDomainDialog;
